/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_New_Sources_TitleInputs */

const vi_scl_new_sources_title = /** @type {(inputs: Scl_New_Sources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô phân loại nguồn`)
};

/**

* @param {Scl_New_Sources_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_sources_title = /** @type {((inputs?: Scl_New_Sources_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Sources_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_sources_title(inputs)
});